export default __webpack_public_path__ + "static/component-12cebb2cd7ba52a1870255ffb81d39d6.png";